export enum ContentType {
   IMAGE = 'IMAGE',
   VIDEO = 'VIDEO',
   PDF = 'PDF',
   NOT_SUPPORTED='NOT SUPPORTED'
   
}